<template>
  <div
    :class="[currIsPc ? '' : 'mobile-bottom-mobile', 'dialog-modal']"
    v-if="visible"
  >
    <div class="mask"></div>
    <div :class="[visible ? 'aniZoomIn' : '', 'dialog-content']">
      <div class="close" @click="close"></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { isPc } from "@/util/index";
export default {
  props: ["visible"],
  data() {
    return {
      top: 0
    };
  },
  computed: {
    currIsPc() {
      return isPc();
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.fixedDoc();
        } else {
          this.unlock();
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    //弹框弹出时禁止弹层下滚动
    fixedDoc() {
      let bodyEl = document.body;
      this.top = window.scrollY;
      bodyEl.style.position = "fixed";
      bodyEl.style.top = -this.top + "px";
    },
    //弹框关闭，打开滚动
    unlock() {
      let bodyEl = document.body;
      bodyEl.style.position = "";
      bodyEl.style.top = "";

      window.scrollTo(0, this.top); // 回到原先的top
    }
  }
};
</script>

<style lang="scss">
@keyframes zoomIn {
  from {
    opacity: 0;
    // transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}
.dialog-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
  }
  .dialog-content {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1002px;
    height: 602px;
    transform: translate(-50%, -50%);
    @include bg("dmodal.png");
    &.aniZoomIn {
      //  animation-name: zoomIn;
      animation: zoomIn 0.3s linear;
    }
    .close {
      position: absolute;
      top: 30px;
      right: 28px;
      width: 34px;
      height: 34px;
      @include bg("close.png");
    }
  }

  &.mobile-bottom-mobile {
    .dialog-content {
      @include wh(682, 803);
      @include bg("mdmodal.png");
      .close {
        position: absolute;
        @include rt(28, 30);
        @include wh(33, 33);
      }
    }
  }
}
</style>
